import { Button, Separator } from '@/components/atoms';
import { useOutletContext } from 'react-router';
import { Mail } from 'lucide-react';
import type { OutletContext } from '@/components/layouts';
import { ContinueWithGoogle } from '@/components/molecules';

export const SignUpForm = () => {
  const { incrementStep, setOrigin } = useOutletContext<OutletContext>();
  const continueWithEmail = () => {
    setOrigin('email');
    incrementStep();
  };

  return (
    <div className="grid grid-cols-2 gap-6 px-4 md:px-6 lg:px-8">
      <Button onClick={continueWithEmail} className="col-span-2" size="lg">
        <Mail /> Continue with Email
      </Button>
      <div className="flex items-center gap-4 relative col-span-2 px-4 md:px-6 lg:px-8">
        <Separator />
        <div className="absolute inset-0 flex items-center justify-center">
          <span className="py-1 px-6 text-center bg-white">or</span>
        </div>
      </div>
      <ContinueWithGoogle />
    </div>
  );
};
